/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Payments_TitleInputs */

const en_admin_payments_title = /** @type {(inputs: Admin_Payments_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Payments`)
};

/**
* | output |
* | --- |
* | "Payments" |
*
* @param {Admin_Payments_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_payments_title = /** @type {((inputs?: Admin_Payments_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Payments_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_payments_title(inputs)
});
export { admin_payments_title as "admin.payments.title" }